import { useRef, type PointerEvent, type ReactNode } from 'react';

/**
 * Metallic card whose 1px border lights up with a gold rim that tracks the
 * cursor. The glow lives entirely in the `.spotlight` pseudo-elements (see
 * styles/index.css); here we only feed it the local pointer position via the
 * --mx/--my custom properties, set directly on the element (not a parent) so
 * it never recalculates children. Pure hover decoration: no layout shift.
 */
export function SpotlightCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  function handleMove(e: PointerEvent<HTMLDivElement>) {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
    el.style.setProperty('--my', `${e.clientY - rect.top}px`);
  }

  return (
    <div
      ref={ref}
      onPointerMove={handleMove}
      className={`spotlight surface-metallic rounded-lg ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
